import src from "IMAGE";
export default { src, width: 285, height: 83, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AN7MsPLY2tT/3eTp/+Hn7P/g4+L/9+7Z//zy4P/38OP6AMG5ree+yc/0yNHW9MbP1fTL0NH06N/N9OvgzPTn3s3wSto4LiwrBloAAAAASUVORK5CYII="};
